module.exports = __webpack_public_path__ + "img/custom.75ded970.jpg";